module.exports = __webpack_public_path__ + "img/日光節約icon.3190d41f.svg";